import styled, { keyframes } from "styled-components";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    position: relative;
    justify-content: center;
    width: 180px;
    height: 180px;
  }
`;

const AnimateBorder = keyframes`
   0% {
      stroke-dasharray: 0, 1000;
      opacity: 1;
    }
    100% {
        stroke-dasharray: 1000, 1000;
        opacity: 1;
    }
`;

const AnimateCheck = keyframes`
   0% {
        stroke-dasharray: 1,200;
        opacity: 1;
    }
    100% {
        stroke-dasharray: 200,200;
        opacity: 1;
    }
`;

const AnimationLine = keyframes`
    0% {
        stroke-dasharray: 0, 200;
        opacity: 1;
    }
    100% {
        stroke-dasharray: 200,200;
        opacity: 1;
    }
`;

const Border = styled.svg.attrs((props) => props.theme.attributes.base)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const Circle = styled.circle.attrs((props) => {
  return {
    ...props.theme.attributes.base,
    cx: "90px",
    cy: "90px",
    r: "80px",
    fill: "none",
  };
})`
  stroke-width: 4;
  stroke-linecap: round;
  opacity: 0;
  animation: 2s ${AnimateBorder} ease-out;
  animation-fill-mode: forwards;
`;

const Check = styled.svg.attrs((props) => props.theme.attributes.base)`
  ${(props) => props.theme.styles.row}
  & {
    position: absolute;
    justify-content: center;
    width: 70px;
    height: 70px;
    stroke-linecap: round;
  }
`;

const CheckPath = styled.path.attrs((props) => props.theme.attributes.base)`
  fill: none;
  opacity: 0;
  transform: translateY(-20px);
  animation: 2s ${AnimateCheck} ease-out;
  animation-delay: 1s;
  animation-fill-mode: forwards;
  stroke-linecap: round;
  stroke-width: 4;
`;

const Cross = styled.svg`
  ${(props) => props.theme.styles.row}
  & {
    position: absolute;
    justify-content: center;
    width: 70px;
    height: 70px;
    stroke-width: 3;
    stroke-linecap: round;
  }
`;

const CrossPath = styled.path.attrs((props) => props.theme.attributes.base)`
  fill: none;
  opacity: 0;
  animation-delay: 1s;
  stroke-linecap: round;
  stroke-width: 4;

  &:first-child {
    animation: 2s ${AnimationLine} ease-out;
    animation-fill-mode: forwards;
  }

  &:last-child {
    animation: 2s ${AnimationLine} ease-out;
    animation-fill-mode: forwards;
  }
`;

const Wrapper = styled(WrapperPartial)`
  &[data-purpose="success"] {
    svg {
      stroke: ${(props) => props.theme.colors.green};
    }
  }
  &[data-purpose="warning"] {
    svg {
      stroke: ${(props) => props.theme.colors.yellow};
    }
  }
  &[data-purpose="fail"] {
    svg {
      stroke: ${(props) => props.theme.colors.red};
    }
  }
`;

interface Props {
  purpose?: "success" | "warning" | "fail";
}

export default function Checkmark({ purpose = "success" }: Props) {
  return (
    <Wrapper data-purpose={purpose}>
      <Border>
        <Circle />
      </Border>
      {purpose === "success" && (
        <Check viewBox={"0 0 180 180"}>
          <CheckPath d={"M 40 130 L 90 160 L 160 60"} />
        </Check>
      )}
      {["fail", "loading"].includes(purpose) && (
        <Cross viewBox={"0 0 180 180"}>
          <CrossPath d={"M 40 40 L 140 140"} />
          <CrossPath d={"M 140 40 L 40 140 "} />
        </Cross>
      )}
    </Wrapper>
  );
}
